import { render, staticRenderFns } from "./userDashboardTrainingPlans.vue?vue&type=template&id=9435b9e6&scoped=true"
import script from "./userDashboardTrainingPlans.vue?vue&type=script&lang=js"
export * from "./userDashboardTrainingPlans.vue?vue&type=script&lang=js"
import style0 from "./userDashboardTrainingPlans.vue?vue&type=style&index=0&id=9435b9e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9435b9e6",
  null
  
)

export default component.exports